import { buildCellNumberMap } from "../model/cellIndexUtils";
import { getComponentPreset } from "../model/defaultComponents";

/**
 * @typedef {{ label: string, id: string, nodeType: "grid" | "column" | "component", rowId?: string, gridId?: string }} BreadcrumbSegment
 */

/**
 * Full path from top-level layout to the selected node.
 * @returns {BreadcrumbSegment[]}
 */
export const buildEditorBreadcrumb = (layout, targetId) => {
  if (!layout || !targetId) {
    return [];
  }

  /** @type {BreadcrumbSegment[]} */
  const path = [];

  /**
   * @param {object} grid
   * @param {BreadcrumbSegment[]} ancestors
   */
  const searchGrid = (grid, ancestors) => {
    if (grid.id === targetId) {
      path.push(...ancestors);
      return true;
    }

    const cellMap = buildCellNumberMap(grid);
    for (const row of grid.rows || []) {
      for (const column of row.columns || []) {
        const cellLabel = `Cella ${cellMap.get(column.id)}`;
        const cellSegment = {
          label: cellLabel,
          id: column.id,
          nodeType: "column",
          rowId: row.id,
          gridId: grid.id,
        };
        if (column.id === targetId) {
          path.push(...ancestors, cellSegment);
          return true;
        }

        for (const child of column.children || []) {
          if (child.id === targetId) {
            if (child.type === "component") {
              path.push(...ancestors, cellSegment, {
                label: getComponentPreset(child.componentKey).label,
                id: child.id,
                nodeType: "component",
              });
            } else {
              path.push(...ancestors, cellSegment, {
                label: child.name?.trim() || "Layout interno",
                id: child.id,
                nodeType: "grid",
              });
            }
            return true;
          }
          if (child.type === "grid") {
            const nestedName = child.name?.trim() || "Layout interno";
            const nestedSegment = { label: nestedName, id: child.id, nodeType: "grid" };
            if (searchGrid(child, [...ancestors, cellSegment, nestedSegment])) {
              return true;
            }
          }
        }
      }
    }
    return false;
  };

  for (let index = 0; index < (layout.grids || []).length; index += 1) {
    const grid = layout.grids[index];
    const gridLabel = grid.name?.trim() || `Layout ${index + 1}`;
    const gridSegment = { label: gridLabel, id: grid.id, nodeType: "grid" };
    if (searchGrid(grid, [gridSegment])) {
      break;
    }
  }

  return path;
};
